import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Logo from './Logo';
import LanguageToggle from './LanguageToggle';
import ThemeToggle from './ThemeToggle';
import { useAppUrl } from '../lib/appUrl';

export default function Header() {
  const { t } = useTranslation();
  const appUrl = useAppUrl();
  return (
    <header className="sticky top-0 z-10 border-b border-border bg-bg/80 backdrop-blur">
      <div className="mx-auto flex max-w-6xl items-center justify-between px-4 py-3">
        <NavLink to="/" className="flex items-center gap-2">
          <Logo className="h-9 w-auto" />
        </NavLink>

        <nav className="hidden gap-6 text-sm md:flex">
          <NavLink to="/" className="text-text-muted transition hover:text-text">
            {t('nav.home')}
          </NavLink>
          <NavLink to="/pricing" className="text-text-muted transition hover:text-text">
            {t('nav.pricing')}
          </NavLink>
        </nav>

        <div className="flex items-center gap-3">
          <ThemeToggle />
          <LanguageToggle />
          <a
            href={appUrl()}
            className="hidden rounded-md border border-border px-3 py-1 text-sm text-text-muted transition hover:border-border-strong hover:text-text sm:inline-block"
          >
            {t('nav.login')}
          </a>
          <a
            href={appUrl()}
            className="rounded-md bg-primary px-4 py-1.5 text-sm font-medium text-primary-fg transition hover:bg-primary-hover"
          >
            {t('nav.getStarted')}
          </a>
        </div>
      </div>
    </header>
  );
}
